export default __webpack_public_path__ + "static/media/h6.07309f1f.png";